import cn from "classnames";
import { Col, Row, Stack } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className, items, EditableText, EditableHtml, EditableImage }) {
  return (
    <div className={cn(className, classes.OrganisationCards, "gap-3")}>
      {items.map((item, idx) => (
        <div key={idx} className="bg-light p-4">
          <Stack className="flex-column-reverse flex-lg-row row-gap-4 column-gap-5">
            <div>
              <EditableText path={`${idx}_title`} tag="h4">
                <span dangerouslySetInnerHTML={{ __html: item.title }} />
              </EditableText>

              <EditableHtml path={`${idx}_content`}>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </EditableHtml>
            </div>
            <div
              style={{
                maxWidth: "306px",
                margin: "0 auto",
              }}
              className="text-center"
            >
              <EditableImage
                path={`${idx}_logo`}
                src={item.logo}
                alt={`${item.title} logo`}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "138px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          </Stack>
          <Row>
            <Col>
              {item.images[0] && (
                <EditableImage
                  path={`${idx}_content_0`}
                  className="w-100 h-100 object-fit-cover"
                  src={item.images[0]}
                  alt=""
                />
              )}
            </Col>
            <Col>
              {item.images[1] && (
                <EditableImage
                  path={`${idx}_content_1`}
                  className="w-100 h-100 object-fit-cover"
                  src={item.images[1]}
                  alt=""
                />
              )}
            </Col>
            <Col>
              {item.images[2] && (
                <EditableImage
                  path={`${idx}_content_2`}
                  className="w-100 h-100 object-fit-cover"
                  src={item.images[2]}
                  alt=""
                />
              )}
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );
}
